import { FC, CSSProperties } from 'react';
// 组件
import { ProSpin } from '../../antd';
// 常量
import { SpinProps } from 'antd/lib/spin';

export interface PageLoadingProps extends SpinProps {
  /** 自定义样式 */
  style?: CSSProperties;
}

export const PageLoading: FC<PageLoadingProps> = props => {
  const { spinning, style, ...resProps } = props;
  if (!spinning) return null;
  let newStyle: CSSProperties = {};
  if (window._isFullPage) {
    newStyle = {
      left: 0,
      top: 0,
    };
  }
  return (
    <div className="page-loading-wrapper" style={{ ...newStyle, ...style }}>
      <ProSpin spinning={spinning} {...resProps} />
    </div>
  );
};

export default PageLoading;
